export interface NavigatorUAData {
  platform: string;
  getHighEntropyValues(
    hints: string[],
  ): Promise<{
    platform?: string;
    platformVersion?: string;
    architecture?: string;
  }>;
}

export function getUserAgentData(): NavigatorUAData | undefined {
  return (navigator as Navigator & { userAgentData?: NavigatorUAData })
    .userAgentData;
}

/**
 * Detect the browser's operating system using the User-Agent Client Hints API
 * when available, falling back to the basic platform hint.
 *
 * Returns a string like "macOS 14.2.0" or "Windows 10.0.0", or undefined if
 * detection fails.
 */
export async function getBrowserOS(): Promise<string | undefined> {
  try {
    const uaData = getUserAgentData();
    if (!uaData) {
      return undefined;
    }
    const hints = await uaData.getHighEntropyValues([
      "platform",
      "platformVersion",
    ]);
    if (hints.platform) {
      return hints.platformVersion
        ? `${hints.platform} ${hints.platformVersion}`
        : hints.platform;
    }
    return uaData.platform || undefined;
  } catch (error) {
    console.error("Failed to get browser OS", error);
    return undefined;
  }
}
